import { Link } from 'react-router-dom';

import LogoImage from '~/shared/assets/logo.svg';
import { routes } from '~/shared/config/routes';
import { cn } from '~/shared/lib/cn';

import { Logotype } from './Logotype';

type Properties = React.HTMLAttributes<HTMLDivElement>;

export function Logo({ className, ...properties }: Properties) {
  return (
    <Link to={routes.home.get()}>
      <div
        className={cn('flex items-center gap-2 sm:gap-4', { className })}
        {...properties}
      >
        <LogoImage className="h-16 w-16 sm:h-20 sm:w-20" />
        <Logotype />
      </div>
    </Link>
  );
}
